<template>
  <div class="check-root">
    <!-- 头部 -->
    <div class="header">
      <el-checkbox v-model="checkAll" @change="changeAll">
        {{ title }}
      </el-checkbox>
      <div class="num">{{ checkNum }}</div>
    </div>
    <div class="search" v-if="showSearch">
      <el-input size="small" clearable placeholder="请输入名称搜索" v-model="searchName" @input="inputChange">
      </el-input>
    </div>
    <!-- 列表 -->
    <div class="main" style="width: 94%;">
      <virtual-list class="check-virtual-list" :keeps="50" :key="virtualKey" :data-key="dataValue"
        :data-sources="dataSources" :data-component="dataComponent" :extra-props="extraProps" />
    </div>
    <el-checkbox class="visiable-check" v-model="checkVisiable" @change="toggleVisiable">
      勾选可见
    </el-checkbox>
  </div>
</template>

<script>
import VirtualList from "vue-virtual-scroll-list";
import List from "./listItem.vue";
export default {
  name: "VirtualTransfer",
  components: {
    "virtual-list": VirtualList,
  },
  props: {
    basedata: {
      type: Array,
      default: () => {
        return [];
      },
    },
    width: {
      type: String,
      default: "90%",
    },
    title: {
      type: String,
      default: "",
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    dataValue: {
      type: String,
      default: "value",
    },
    dataLabel: {
      type: String,
      default: "label",
    },
  },
  data() {
    return {
      // 头部
      checkAll: false,
      checkVisiable: false,
      searchName: "",
      // 列表
      dataSources: [],
      dataComponent: List,
      extraProps: {
        checkMap: {},
        dataLabel: this.dataLabel,
        dataValue: this.dataValue,
      },
      virtualKey: 0, // 用于强制更新视图
      // 其他
      checkMap: {},
      allCheckMap: {},
    };
  },
  mounted() {
    this.initData();
    // 订阅勾选事件
    this.$on("virtual-transfer-check-change", (key, val) => {
      this.checkMap[key] = val;
      this.extraProps["checkMap"] = this.checkMap;
      this.handleResult();
    });
  },
  watch: {
    basedata() {
      this.initData();
    },
  },
  computed: {
    checkNum() {
      let num = 0;
      for (let key in this.checkMap) {
        this.checkMap[key] ? num++ : "";
      }
      return `${num}/${this.basedata.length}`;
    },
  },
  methods: {
    // 初始化数据
    initData() {
      this.$nextTick(() => {
        this.checkAll = false;
        this.allCheckMap = {};
        this.checkMap = {};
        this.extraProps["checkMap"] = this.checkMap;
        this.basedata.forEach((res) => {
          this.allCheckMap[res[this.dataValue]] = true;
        });
        this.dataSources = this.basedata;
        this.virtualKey++;
      });
    },
    toggleVisiable(val) {
      const arr = this.basedata.filter(i => i.visiable);
      let obj = {}
      if (val) {
        arr.forEach(i => {
          obj[i.id] = true
        })
      }
      this.checkMap = obj
      this.extraProps["checkMap"] = this.checkMap;
      this.virtualKey++;
      this.handleResult();
    },

    // 全选
    changeAll(val) {
      val
        ? (this.checkMap = JSON.parse(JSON.stringify(this.allCheckMap)))
        : (this.checkMap = {});
      this.extraProps["checkMap"] = this.checkMap;
      this.virtualKey++;
      this.handleResult();
    },

    // 搜索
    inputChange() {
      this.$nextTick(() => {
        this.checkAll = false;
        this.allCheckMap = {};
        // 正则匹配
        let arr = [];
        let searcReg = new RegExp(String(this.searchName));
        this.basedata.forEach((res) => {
          if (
            searcReg.test(String(res[this.dataLabel])) ||
            searcReg.test(String(res[this.dataValue]))
          ) {
            this.allCheckMap[res[this.dataValue]] = true;
            arr.push(res);
          }
        });
        this.dataSources = arr;
        this.virtualKey++;
      });
    },

    // 处理结果
    handleResult() {
      let arr = [];
      for (let key in this.checkMap) {
        this.checkMap[key] === true ? arr.push(key) : "";
      }
      console.log(this.checkMap);
      console.log(arr);
      this.$emit("check-change", arr);
    },
  },
};
</script>

<style scoped>
.visiable-check {
  margin: 5px 18px;
}

.check-root {
  border: 1px solid #ebeef5;
}

.check-root .header {
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
  background-color: #f5f7fa;
  display: flex;
  justify-content: space-between;
}

.check-root .header .num {
  color: #909399;
}

.check-root .search {
  padding: 5px 20px;
}

.check-root .search ::v-deep .el-input__inner {
  border-radius: 10px;
}

.check-root .main {
  background-color: #fff;
  padding: 0 10px;
}

.check-root .main .check-virtual-list {
  height: 400px;
  overflow: auto;
  padding: 0 10px;
}
</style>
